<script setup>
import Hero from "./components/Home/Hero.vue";
import FilterModal from "./components/Filter/FilterModal.vue";
import { ModalsContainer, useModal } from "vue-final-modal";
import { computed, nextTick, ref, useTemplateRef, watch } from "vue";
import { useFilterStore } from "./stores/filter";
import { useCollectionStore } from "./stores/collection";
import InfiniteArticleList from "./components/ArticleList/InfiniteArticleList.vue";
import { useResultsStore } from "./stores/results";

// Stores
const filterStore = useFilterStore();
const resultsStore = useResultsStore();
const collectionStore = useCollectionStore();

// Different from results store loading state, but when results store is finished loading, this isLoading is also false
const isReloading = ref(true);

// Filter Modal
const filterModal = useModal({
  component: FilterModal,
  attrs: {
    onClose() {
      filterModal.close();
    },
    onClosed() {
      load();
    },
  },
});

// Order
async function toggleOrder() {
  filterStore.toggleOrder();
  window.klarnachrichten.trackMatomoEvent("toggle-order", filterStore.order);
  load();
}

// Unseen
const unseen = ref(false);
async function toggleUnseen() {
  unseen.value = !unseen.value;
  window.klarnachrichten.trackMatomoEvent("toggle-unseen", unseen.value ? "true" : "false");
  load();
}

async function init() {
  await collectionStore.init();
  await filterStore.init();

  if (collectionStore.activeCollection) {
    filterStore.applyCollectionFilters(collectionStore.activeCollection.filters);
    await nextTick();
  }

  load();
}

const filters = computed(() => {
  const filterQueryParams = structuredClone(filterStore.filterQueryParams);

  if (unseen.value) {
    const articleHistory = window.klarnachrichten.articleHistory.getHistory();
    if (articleHistory.length > 0) {
      filterQueryParams["exclude-ids"] = articleHistory;
    }
  }

  return filterQueryParams;
});

async function load() {
  isReloading.value = true;
  await resultsStore.fetchResults(filters.value);
  isReloading.value = false;
}

async function refresh() {
  window.klarnachrichten.trackMatomoEvent("refresh");
  await load();
}

init();
</script>

<template>
  <Hero
    @open-filter="filterModal.open()"
    @toggle-order="toggleOrder()"
    @toggle-unseen="toggleUnseen()"
    @refresh="refresh()"
  />

  <InfiniteArticleList class="container transition-opacity" :filters="filters" :is-reloading="isReloading" />

  <ModalsContainer />
</template>
